document.addEventListener("DOMContentLoaded", function () {
    setTimeout(async function () {
      const items = document.querySelectorAll(".cart-item-custom");

      for (const item of items) {
        const lineItemKey = item.dataset.key;
        const customQty = parseInt(item.dataset.customQty);
        const rawPrice = item.dataset.unitPrice || ""; // e.g. "$30.00"

        const input = item.querySelector(".cart-item__quantity-input");
        const priceDisplay = item.querySelector(".cart-item__selling-total");

        if (!lineItemKey || isNaN(customQty)) {
          console.warn("❌ Skipping item — invalid data", { lineItemKey, customQty });
          continue;
        }

        // ✅ Update cart only once
        const updatedKey = "updated_" + lineItemKey;
        if (!localStorage.getItem(updatedKey)) {
          try {
            const response = await fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                id: lineItemKey,
                quantity: customQty
              })
            });

            if (response.ok) {
              localStorage.setItem(updatedKey, "true");
              console.log(`✔ Quantity updated for ${lineItemKey}`);
            } else {
              console.error("❌ Shopify cart update failed");
            }
          } catch (err) {
            console.error("❌ Fetch error:", err);
          }
        }


        // ✅ Display price string with quantity (no math)
        if (priceDisplay) {
          priceDisplay.textContent = `${rawPrice}`;
        }
      }
    }, 2000); // 2-second delay after page load
  });